import { useState } from "react";
import { DATA } from "../../data";

import {
    motion,
    useScroll,
    useSpring,
    useTransform,
    useMotionValue,
    useVelocity,
    useAnimationFrame
  } from "framer-motion";

import { wrap } from "@motionone/utils";

import { useRef } from "react";

const ListRow = (props, {children, baseVelocity = 100*props.baseVelocity}) => {
        const baseX = useMotionValue(0);
        const { scrollY } = useScroll();
        const scrollVelocity = useVelocity(scrollY);
        const smoothVelocity = useSpring(scrollVelocity, {
          damping: 50,
          stiffness: 400
        });
        const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
          clamp: false
        });
      
        /**
         * This is a magic wrapping for the length of the text - you
         * have to replace for wrapping that works for you or dynamically
         * calculate
         */
        const wRef = useRef();
        const x = useTransform(baseX, (v) => `${wrap(0, (wRef.current ? -wRef.current.offsetWidth : 0), v)}px`);
      
        const directionFactor = useRef(1);
        useAnimationFrame((t, delta) => {
          let moveBy = directionFactor.current * baseVelocity * (delta / 1000);
      
          /**
           * This is what changes the direction of the scroll once we
           * switch scrolling directions.
           */
          if (velocityFactor.get() < 0) {
            directionFactor.current = -1;
          } else if (velocityFactor.get() > 0) {
            directionFactor.current = 1;
          }
        //   if (props.company) (console.log(props.company));
        moveBy += directionFactor.current * moveBy * velocityFactor.get();
      
        if (props.company == "")baseX.set(baseX.get() + moveBy);
        //   console.log(wRef.current.offsetWidth);
        });

        return (
            <motion.div
          className="hidden z-30 desktop:flex desktop:font-apfelgrotezk desktop:text-[80px] desktop:mt-[120px] h-50 mb-[70px]
                      "
        //   onScroll={handleScrollFirst}
        //   ref={firstDivRef}
          id=""
          style={{x}}
        >
            <div className="rowGroup desktop:flex gap-x-16" ref={wRef}>
            {props.items.map((item, i) => (
            <div
                // onMouseOver={props.handler(item.name)}
                // onMouseOut={props.handler(item.name)}
                key = {i}
                href={item.href}
                target="_blank"
                className=""
              >
                <a href={item.href} target="_blank">
                <h2
                onMouseOver={() => props.handler(item.name)}
                onMouseOut={() => props.handler(item.name)}
                  className={`mr-[200px] w-max uppercase transition-all duration-300 ease ${
                    props.company !== "" && props.company !== item.name
                      ? "opacity-30"
                      : "opacity-100"
                  }`}
                >
                  {item.name}
                </h2>
                </a>
  
                <div className={`overflow-hidden`}>
                  <p
                    className={`text-[20px] pb-3 transition-all duration-200 ${
                      props.company === item.name ? "opacity-100" : "opacity-0"
                    } ${props.company === item.name ? "visible" : "invisible"}`}
                  >
                    {item.position}
                  </p>
                </div>
              </div>))}
              </div>
              <div className="rowGroup desktop:flex gap-x-16" ref={wRef}>
            {props.items.map((item, i) => (
            <div
                key = {i}
                href={item.href}
                target="_blank"
                className=""
              >
                <a href={item.href} target="_blank">
                <h2
                onMouseOver={() => props.handler(item.name)}
                onMouseOut={() => props.handler(item.name)}
                  className={`mr-[200px] w-max uppercase transition-all duration-300 ease ${
                    props.company !== "" && props.company !== item.name
                      ? "opacity-30"
                      : "opacity-100"
                  }`}
                >
                  {item.name}
                </h2>
                </a>
  
                <div className={`overflow-hidden`}>
                  <p
                    className={`text-[20px] pb-3 transition-all duration-200 ${
                      props.company === item.name ? "opacity-100" : "opacity-0"
                    } ${props.company === item.name ? "visible" : "invisible"}`}
                  >
                    {item.position}
                  </p>
                </div>
              </div>))}
              </div>
            </motion.div>
        );

}

function List() {
  const test = DATA.list;
  const [company, setCompany] = useState("");

  function toggle(string) {
    if (company != string) {
      setCompany(string);
    } else {
      setCompany("");
    }
  }

  const handler = (inString) => {
    toggle(inString);
  }

  var list1 = test.map((x) => x);
  var list2 = list1.splice(0, 4);

//   const makeRepeated = (arr, repeats) =>
//     [].concat(...Array.from({ length: repeats }, () => arr));

// //   list2 = makeRepeated(list2, 100);
//   list1 = makeRepeated(list1, 4);

//   console.log(list1);

//   const firstDivRef = useRef();
//   const secondDivRef = useRef();

//   const handleScrollFirst = (scroll) => {
//     secondDivRef.current.scrollTop = scroll.target.scrollTop;
//   };

//   const handleScrollSecond = (scroll) => {
//     firstDivRef.current.scrollTop = scroll.target.scrollTop;
//   };

//   var item = document.getElementById("container");

//   window.addEventListener("wheel", function (e) {
//     e.preventDefault();
//     if (e.deltaY > 0) item.scrollLeft += 600;
//     else {
//       item.scrollLeft -= 300;
//     }
//   });





  return (
    <div>
      {/* <Companies/> */}
      <div className="font-apfelgrotezk mt-[60px] ml-[8px] text-[35px] desktop:hidden tablet:ml-[20px] mb-32">
        {test.map((item, i) => (
          // General clickable box
          <div key={i} onClick={() => toggle(item.name)}>
            {/* Heading with */}
            <h2
              className={`uppercase text-4xl cursor-pointer mb-3 ${
                company != item.name && company != "" ? "opacity-30" : ""
              }`}
            >
              {item.name}
              <span
                className={`opacity-40 text-[30px] ml-[8px] ${
                  company != item.name ? "hidden" : ""
                }`}
              >
                &#10005;
              </span>
            </h2>

            <div
              className={`mb-2 overflow-hidden transition-all duration-300 ease ${
                company == item.name && item.position ? " h-[100px]" : "h-0"
              } ${company == item.name && !item.position ? "h-[60px]" : ""} `}
            >
              <p className={`text-paboutmob `}>{item.position}</p>
              <a href={item.href} target="_blank">
                <div
                  className="text-2xl uppercase inline-block box-border border border-chocolate p-2
                 hover:bg-chocolate hover:text-strawberry transition-all duration-300"
                >
                  Visit agency
                </div>
              </a>
            </div>
          </div>
        ))}
      </div>

      <div
        className="overflow-hidden scroll scroll-smooth scrollbar-hide ml-[-50px] mb-32"
        id="container"
      >
        {/* test */}
        <ListRow items={list1} company={company} handler={handler} baseVelocity={-2}/>
        <ListRow items={list2} company={company} handler={handler} baseVelocity={2}/>
      </div>
    </div>
  );
}

export default List;
